export default "__VITE_ASSET__Cqvkpwxc__"